<template>
  <div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
      style="margin-top: 25px"
    >
      <h2>Operator Role Management</h2>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <v-divider></v-divider>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
    <div
      :style="{
        marginLeft: generalSpacingLeftRight + '%',
        marginRight: generalSpacingLeftRight + '%',
      }"
    >
      <v-card outlined>
        <v-data-table
          :headers="headers"
          :items="role_list"
          :loading="table_loading"
          loading-text="Loading... Please wait"
          :mobile-breakpoint="0"
          :search="search"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search Role"
                  single-line
                  hide-details
                  color="primary"
                ></v-text-field>
              </v-toolbar-title>
              <!-- <v-spacer></v-spacer>
              <v-btn
                depressed
                color="primary"
                dark
                style="text-transform: capitalize"
                @click="create_machine"
                v-if="current_user_company_doc_id == ''"
              >
                <v-icon left dark> mdi-plus </v-icon>
                Create Machine
              </v-btn> -->
            </v-toolbar>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <div style="margin-top: 25px; margin-bottom: 25px"></div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      headers: [
        {
          text: "Role Name",
          value: "role_name",
          sortable: true,
          divider: true,
        },
        {
          text: "Description",
          value: "description",
          sortable: true,
          divider: true,
        },
      ],
      role_list: [],
      table_loading: false,
      search: "",
      current_user_company_doc_id: "",
    };
  },
  methods: {
    load_roles() {
      this.table_loading = true;
      this.send_http_request("getAllRoles", {})
        .then((response) => {
          this.table_loading = false;
          if (response.data.status == "OK") {
            this.role_list = response.data.result;
          }
        })
        .catch((error) => {
          this.table_loading = false;
          console.log(error);
        });
    },
  },
  mounted() {
    this.load_roles();
  },
  created() {
    this.current_user_company_doc_id = this.$store.getters.getUserCompanyDocId;
    if (this.current_user_company_doc_id != "") {
      this.$router.push({ name: "HomeScreen" }).catch((err) => {});
    }
    // Update store
    var payload = { headerType: "needHeader", currentPage: "RoleScreen" };
    this.$store.dispatch("updateHeaderType", payload);
    this.$store.dispatch("updateCurrentPage", payload);
  },
  computed: {
    generalSpacingLeftRight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 5;
        case "sm":
          return 5;
        case "md":
          return 3;
        case "lg":
          return 3;
        case "xl":
          return 3;
        default:
          return 5;
      }
    },
  },
};
</script>

<style>
</style>